import {
  Box,
  Container,
  Heading,
  // HStack,
  //   Stack,
  //   VStack,
  FormControl,
  Breadcrumb,
  BreadcrumbItem,
  Text,
  FormHelperText,
  HStack,
  useDisclosure,
  useToast,
  useUpdateEffect,
  CircularProgress,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

// import { useParams } from "react-router-dom";
import { useCallback, useMemo, useState } from "react";
import Select from "components/Select/Select";
import Button from "components/Button/Button";
import { NumberInputWithMax } from "components/Input/NumberInput";
// import toPrecision from "util/toPrecision";
import Preview from "components/Modals/swap/SwapPreview";
import toPrecision from "util/toPrecision";

import capitalize from "lodash/capitalize";
import toCoinLocale from "util/toCoinLocale";

import constant from "config/constant";
import {
  useCalcReturnMutation,
  useGetEarnWalletQuery,
  useGetStakingPlansQuery,
  useStakeMutation,
} from "services/walletApi";
import SuccessModal from "components/Modals/Success";
import getError from "util/getError";
import { useHistory } from "react-router-dom";
import SubmitPin from "components/Modals/SubmitPin";

export default function Subscribe(props) {
  const currentPage = "Earn";

  const toast = useToast();
  const history = useHistory();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isPinOpen,
    onClose: onPinClose,
    onOpen: onPinOpen,
  } = useDisclosure();

  const {
    isOpen: isSuccessOpen,
    onClose: onSuccessClose,
    onOpen: onSuccessOpen,
  } = useDisclosure();

  const params = new URLSearchParams(props?.location?.search);

  const [state, _set] = useState({
    coin: params.get("coin"),
    subType: params.get("type") ?? null,
  });

  const set = useCallback(
    (update) => _set((old) => ({ ...old, ...update })),
    []
  );

  const coin = useMemo(() => {
    const map = {
      [state?.coin]: state?.coin,
      tbtc: "btc",
      teth: "eth",
    };

    return map[state?.coin ?? "tbtc"];
  }, [state?.coin]);

  const { data: earnData } = useGetEarnWalletQuery();

  const { data: planData, isLoading: isLoadingPlans } = useGetStakingPlansQuery(
    { skip: !state?.coin }
  );

  const plans = useMemo(() => planData?.plans, [planData]);
  const plan = useMemo(() => plans && plans[coin], [plans, coin]);

  console.log("PLAN DATA", plans, plan);

  const wallets = useMemo(() => earnData?.wallets, [earnData]);
  const selectedWallet = useMemo(
    () => state?.coin && wallets?.find((w) => w?.unit === state?.coin),
    [state?.coin, wallets]
  );

  const balance = useMemo(
    () => selectedWallet?.balance?.$numberDecimal,
    [selectedWallet]
  );

  const isInsufficientBalance = useMemo(
    () => state?.amount && +state?.amount > +balance,
    [state?.amount, balance]
  );

  const isLessThanMinimum = useMemo(
    () => state?.amount && plan?.minimum && state?.amount < plan?.minimum,
    [state?.amount, plan]
  );

  console.log("SELECT WALLET", selectedWallet);

  const handleSuccessClose = () => {
    onSuccessClose();
    _set({ coin: params.get("coin") });
    history.push(`/dashboard/earn/earnings/${params.get("coin")}`);
  };

  const [_stake, { isLoading, error, isError, isSuccess }] = useStakeMutation();

  const [_calcReturns, { data: returns, isLoading: isCalculating }] =
    useCalcReturnMutation();

  console.log("RETURNS", returns);

  const apr = useMemo(() => +returns?.apr, [returns]);

  const fee = useMemo(() => {
    const reward = (state?.amount * (apr * +state?.duration)) / 365;
    if (returns?.fee?.factor === "percentage")
      return reward * (+returns?.fee?.rate / 100);
    if (returns?.fee?.factor === "fixed") return +returns?.fee?.fixed;
    return 0;
  }, [state?.amount, apr, state?.duration, returns?.fee]);

  const rewards = useMemo(
    () => (state?.amount * (apr * +state?.duration)) / 365 - fee,
    [state?.amount, apr, state?.duration, fee]
  );

  const stake = (pin) => {
    const reqData = {
      amount: +state?.amount,
      coin: state?.coin,
      pin: pin ?? state?.pin,
      duration: +state?.duration,
      flexible: state?.subType === "flexible" ? true : false,
      autoRenew: state?.autoRollover === "yes" ? true : false,
    };

    _stake({ ...reqData });
  };

  const calcReturns = () => {
    const reqData = {
      amount: +state?.amount,
      coin: state?.coin,
      duration: +state?.duration,
      flexible: state?.subType === "flexible" ? true : false,
      autoRenew: state?.autoRollover === "yes" ? true : false,
    };

    _calcReturns({ ...reqData });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onOpen();

    calcReturns();
  };

  // console.log("Transfer", state);

  const isDisabled = useMemo(
    () =>
      !(
        (
          state?.coin &&
          state?.duration &&
          state?.autoRollover &&
          state?.amount &&
          state?.subType
        )
        // && +state?.amount >= 10
      ) ||
      isLoading ||
      isInsufficientBalance ||
      isLessThanMinimum,
    [state, isLoading, isInsufficientBalance, isLessThanMinimum]
  );

  useUpdateEffect(() => {
    if (isSuccess) {
      onClose();
      onSuccessOpen();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, isError, toast, state?.coin, onSuccessOpen]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 30vw)", "calc(100% - 48vw)"]}
            m="0"
            // p="0"
          >
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">Earn</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink
                    to={`/dashboard/earn/staking?coin=${
                      params.get("coin") ?? "usdt"
                    }`}
                  >
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Subscribe
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              mt="20px"
              p={["24px", "56px"]}
              borderRadius={[0, "16px"]}
              border="1px solid #EFF0F7"
              as="form"
              onSubmit={handleSubmit}
            >
              <FormControl mb="22px">
                <Select
                  label="Coin Type"
                  placeholder="Select Coin"
                  value={state?.coin ?? ""}
                  onChange={(e) => {
                    set({ coin: e.target.value });
                    history.replace(
                      `/dashboard/earn/subscribe?coin=${e.target.value}`
                    );
                  }}
                >
                  {constant.supportedStakableCoins.map((coin) => (
                    <option key={`stakable-coin-${coin}`} value={coin}>
                      {toCoinLocale(coin)}
                    </option>
                  ))}
                </Select>

                {/* <FormHelperText>
                  <HStack>
                    <Text>Percentage:</Text>
                    <Text color="var(--primary)" fontWeight="600">
                      20%
                    </Text>
                  </HStack>
                </FormHelperText> */}
              </FormControl>

              <FormControl mb="22px">
                <Select
                  label="Subscription Type"
                  placeholder="Select"
                  isLoading={isLoadingPlans}
                  value={state?.subType ?? ""}
                  onChange={(e) => set({ subType: e.target.value })}
                >
                  {plan?.supported?.map((type) => (
                    <option key={`subscription-type-${type}`} value={type}>
                      {capitalize(type)}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb="22px">
                <Text
                  as="label"
                  d="inline-block"
                  fontSize=".85em"
                  color="#4E4B66"
                  mb="8px"
                >
                  Amount
                </Text>
                <NumberInputWithMax
                  // label="Amount"

                  isInvalid={isInsufficientBalance}
                  placeholder="Enter amount"
                  value={state?.amount ?? ""}
                  onChange={(amount) => set({ amount })}
                />

                {state?.coin && (
                  <FormHelperText>
                    {!isNaN(+balance) && (
                      <HStack>
                        <Text>Available balance: </Text>
                        <Text color="var(--primary)">
                          {toPrecision(balance, state?.coin)}
                        </Text>
                      </HStack>
                    )}
                    <HStack>
                      {plan?.minimum && (
                        <Text color={isLessThanMinimum ? "red.400" : "inherit"}>
                          Minimum amount to stake:{" "}
                          {toPrecision(plan?.minimum, state?.coin)}
                        </Text>
                      )}
                    </HStack>
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl mb="22px">
                {state?.subType === "fixed" && (
                  <Select
                    label="Duration"
                    placeholder="Select Duration"
                    isLoading={isLoadingPlans}
                    value={state?.duration ?? ""}
                    onChange={(e) => set({ duration: e.target.value })}
                  >
                    {plan?.tenor?.map((tenor) => (
                      <option key={`tenor-${tenor}`} value={tenor}>
                        {tenor} days
                      </option>
                    ))}
                  </Select>
                )}

                {state?.subType === "flexible" && (
                  <>
                    <Text
                      as="label"
                      d="inline-block"
                      fontSize=".85em"
                      color="#4E4B66"
                      mb="8px"
                    >
                      Duration (days)
                    </Text>
                    <NumberInputWithMax
                      label="Duration"
                      min={1}
                      max={365}
                      step={1}
                      placeholder="Enter duration"
                      value={state?.duration ?? ""}
                      onChange={(duration) =>
                        set({
                          duration: `${
                            isNaN(Math.ceil(duration)) ? 1 : Math.ceil(duration)
                          }`,
                        })
                      }
                    />
                    <FormHelperText>
                      Must be a value between 1 and 365
                    </FormHelperText>
                  </>
                )}
              </FormControl>

              <FormControl mb="8px">
                <Select
                  label="Automatic Rollover"
                  placeholder="Select"
                  value={state?.autoRollover ?? ""}
                  onChange={(e) => set({ autoRollover: e.target.value })}
                >
                  <option value="no">No</option>
                  <option value="yes">Yes</option>
                </Select>

                <FormHelperText fontStyle="italic">
                  Note: Indicate if this subscription should rollover
                  automatically at the end of the determined period. This means
                  that your new principal will be old principal plus earned
                  interest
                </FormHelperText>
              </FormControl>

              <Button
                mt="48px"
                minH="64px"
                w="100%"
                type="submit"
                disabled={isDisabled}
              >
                Subscribe
              </Button>
            </Box>
          </Container>
        </Box>
      </Box>

      <Preview
        isOpen={isOpen}
        onClose={onClose}
        title="Preview"
        data={{
          "Coin Type": toCoinLocale(state?.coin),
          "Annual Percentage": apr
            ? `${Number((+apr ?? 0) * 100).toFixed(2)}%`
            : "0%",
          Amount: toPrecision(state?.amount ?? 0, state?.coin),
          Duration: `${state?.duration} days`,
          "Subscription Type": `${capitalize(state?.subType)}`,
          "Automatic Rollover": capitalize(state?.autoRollover),
          Reward: isCalculating ? (
            <CircularProgress
              isIndeterminate
              size="14px"
              color="var(--primary)"
            />
          ) : (
            toPrecision(rewards, state?.coin, true, 8, true)
          ),
          Fee: isCalculating ? (
            <CircularProgress
              isIndeterminate
              size="14px"
              color="var(--primary)"
            />
          ) : (
            toPrecision(fee, state?.coin, true, 8, true)
          ),
        }}
        onConfirm={onPinOpen}
        buttonText={["Close", "Subscribe"]}
        isLoading={isLoading}
      />

      <SubmitPin
        isOpen={isPinOpen}
        onClose={onPinClose}
        closeOnSubmit
        onSubmit={(pin) => stake(pin)}
      />

      <SuccessModal
        isOpen={isSuccessOpen}
        onClose={handleSuccessClose}
        title="Success"
        message={`You've successfully staked ${toPrecision(
          state?.amount ?? 0,
          state?.coin
        )}`}
      />
    </Box>
  );
}
